import React from 'react';

const Shrug = () => {
  return (
    <svg
      width="34"
      height="35"
      viewBox="0 0 34 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.4999 20.0103H8.49995C6.41367 20.0103 4.72217 21.7018 4.72217 23.7881V34.177H29.2777V23.7881C29.2777 21.7018 27.5862 20.0103 25.4999 20.0103Z"
        fill="#4289C1"
      />
      <path d="M9.44434 25.677H10.3888V34.177H9.44434V25.677Z" fill="#2A6797" />
      <path
        d="M4.44079 25.2001L4.17351 25.1443H3.6909C3.6909 25.0896 3.71263 25.0386 3.72396 24.9847C3.39529 24.7817 3.20829 24.3945 3.2914 23.995C3.39718 23.4831 3.89868 23.1544 4.41151 23.2592L6.38635 23.6682H7.96924C8.78429 23.6682 9.44446 24.3293 9.44446 25.1453V26.6215H5.90563C5.90563 26.6215 4.5069 25.9896 4.44079 25.2001Z"
        fill="#B78B60"
      />
      <path
        d="M0 24.4067C0 23.9987 0.330556 23.6682 0.737611 23.6682L5.16706 24.4067H8.70589C9.11389 24.4067 9.4435 24.7382 9.4435 25.1443V26.6215H4.72222L0.737611 25.1453C0.737611 25.1453 0 24.8147 0 24.4067Z"
        fill="#D5AB88"
      />
      <path
        d="M3.77783 34.177H9.4445V26.6215H4.72228L3.77783 34.177Z"
        fill="#4289C1"
      />
      <path d="M23.6111 25.677H24.5555V34.177H23.6111V25.677Z" fill="#2A6797" />
      <path
        d="M29.5591 25.2001L29.8264 25.1443H30.309C30.309 25.0896 30.2873 25.0386 30.276 24.9847C30.6046 24.7817 30.7916 24.3945 30.7085 23.995C30.6027 23.4831 30.1022 23.1544 29.5893 23.2592L27.6145 23.6682H26.0316C25.2166 23.6682 24.5564 24.3293 24.5564 25.1453V26.6215H28.0952C28.0943 26.6215 29.493 25.9896 29.5591 25.2001V25.2001Z"
        fill="#B78B60"
      />
      <path
        d="M34.0001 24.4067C34.0001 23.9987 33.6696 23.6682 33.2625 23.6682L28.8321 24.4067H25.2933C24.8853 24.4067 24.5557 24.7382 24.5557 25.1443V26.6215H29.2779L33.2625 25.1453C33.2625 25.1453 34.0001 24.8147 34.0001 24.4067Z"
        fill="#D5AB88"
      />
      <path
        d="M30.2223 34.177H24.5557V26.6215H29.2779L30.2223 34.177Z"
        fill="#4289C1"
      />
      <path
        d="M8.5 6.78812V16.2326C8.5 20.9274 12.3052 24.7326 17 24.7326C21.6948 24.7326 25.5 20.9274 25.5 16.2326V6.78812H8.5Z"
        fill="#D5AB88"
      />
      <path
        d="M10.2443 13.1301C10.2443 14.6223 9.48872 15.8321 8.55561 15.8321C7.6225 15.8321 6.86694 14.6223 6.86694 13.1301C6.86694 11.6378 7.62344 10.428 8.55561 10.428C9.48778 10.428 10.2443 11.6378 10.2443 13.1301ZM27.1328 13.1301C27.1328 14.6223 26.3773 15.8321 25.4442 15.8321C24.5111 15.8321 23.7555 14.6223 23.7555 13.1301C23.7555 11.6378 24.5111 10.428 25.4442 10.428C26.3773 10.428 27.1328 11.6378 27.1328 13.1301Z"
        fill="#D5AB88"
      />
      <path
        d="M17 0.954285C10.371 0.954285 7.42432 5.37806 7.42432 9.06517C7.42432 12.7513 8.6927 13.7742 8.89765 12.7513C9.63432 9.06517 11.8443 7.93373 11.8443 7.93373C16.2643 11.6208 15.5276 8.67134 15.5276 8.67134C19.9467 13.0951 17.7376 8.67134 17.7376 8.67134C19.211 10.1466 23.63 10.1466 23.63 10.1466C23.63 10.1466 24.3667 11.278 25.1024 12.7523C25.8391 14.2275 26.5758 12.7523 26.5758 9.06612C26.5758 5.37806 22.8924 0.954285 17 0.954285V0.954285Z"
        fill="#963B22"
      />
      <path
        d="M17.9444 18.5937H16.0555C15.7948 18.5937 15.5833 18.3821 15.5833 18.1215C15.5833 17.8608 15.7948 17.6492 16.0555 17.6492H17.9444C18.205 17.6492 18.4166 17.8608 18.4166 18.1215C18.4166 18.3821 18.205 18.5937 17.9444 18.5937ZM19.361 21.8992H18.8888C18.6281 21.8992 18.4166 21.6877 18.4166 21.427C18.4166 21.1663 18.6281 20.9548 18.8888 20.9548H19.361C19.6217 20.9548 19.8333 21.1663 19.8333 21.427C19.8333 21.6877 19.6217 21.8992 19.361 21.8992Z"
        fill="#BF6952"
      />
      <path
        d="M13.2223 15.2881C12.7009 15.2881 12.2778 14.865 12.2778 14.3437V13.3992C12.2778 12.8779 12.7009 12.4548 13.2223 12.4548C13.7436 12.4548 14.1667 12.8779 14.1667 13.3992V14.3437C14.1667 14.865 13.7436 15.2881 13.2223 15.2881ZM20.7778 15.2881C20.2556 15.2881 19.8334 14.865 19.8334 14.3437V13.3992C19.8334 12.8779 20.2556 12.4548 20.7778 12.4548C21.3001 12.4548 21.7223 12.8779 21.7223 13.3992V14.3437C21.7223 14.865 21.3001 15.2881 20.7778 15.2881Z"
        fill="#662113"
      />
    </svg>
  );
};

export default Shrug;
